export function handleValidateFiles(files: File[]): File[] {
  const validFiles: File[] = Array.from(files).map((file: File) => {
    // if (file?.name?.includes('—')) {
    //   toast.error(`File name: ${file?.name} is not valid!`)
    //   clearCurrentValue()
    //   return {} as File
    // }
    // if (!file?.type.includes('image')) {
    //   toast.error(`${file?.name} is not an image file!`)
    //   clearCurrentValue()
    //   return {} as File
    // }
    return file
  })
  return validFiles
}

export function shortenFileName(fileUrl: string, length: number): string {
  const fileNameFromAWS: string = (fileUrl ?? '').split('/')[3]
  const fileName: string = (fileNameFromAWS ?? '').split('_').slice(1).join('_')
  if (fileName?.length > length) {
    return fileName.slice(0, length) + '...'
  }
  return fileName
}
